import SearchIcon from "@assets/images/search-icon.svg?react";
import classNames from "classnames";

import "./style.scss";

interface SearchBoxProps {
	className?: string;
	value?: string;
	placeholder?: string;
	onChange?: (value: string) => void;
}
const SearchBox = ({ value, onChange, placeholder = "대리점 검색", className }: SearchBoxProps) => {
	return (
		<div className={classNames("search-box", className)}>
			<input
				type="text"
				placeholder={placeholder}
				value={value}
				onChange={(e) => onChange?.(e.target.value)}
			/>
			<SearchIcon className="search-icon" />
		</div>
	);
};

export default SearchBox;
